import { useQuery } from '@tanstack/react-query';

import { getTokenInfo } from '@shared/helpers/web3/erc20/token/getTokenInfo';
import type { Web3Handle } from '@shared/helpers/web3/handle';
import { isWeb3Handle } from '@shared/helpers/web3/handle';

export const useTokenInfo = (
  tokenHandle?: Partial<Web3Handle>,
  options?: { enabled?: boolean },
) => {
  const { enabled = true } = options ?? {};

  return useQuery({
    queryKey: ['tokenInfo', tokenHandle?.address, tokenHandle?.chainId],
    queryFn: () => {
      if (isWeb3Handle(tokenHandle)) {
        return getTokenInfo(tokenHandle);
      }
    },
    enabled: enabled && isWeb3Handle(tokenHandle),
    staleTime: Infinity,
  });
};
